export default __webpack_public_path__ + "static/media/complementary--except-trailers--g2.915ae4eb.png";